"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = function TextArea(_ref) {
  var userMessage = _ref.userMessage,
      handleChange = _ref.handleChange,
      handleKeyPress = _ref.handleKeyPress,
      disabled = _ref.disabled,
      _ref$textareaRef = _ref.textareaRef,
      textareaRef = _ref$textareaRef === void 0 ? null : _ref$textareaRef;
  return /*#__PURE__*/_react.default.createElement("textarea", {
    className: "Chatbot__Messenger__promptTextarea",
    disabled: disabled,
    onChange: handleChange,
    onKeyDown: handleKeyPress,
    placeholder: disabled ? 'Generando respuesta...' : 'Preguntá lo que necesites a GAIA',
    ref: textareaRef,
    rows: 1,
    spellCheck: true,
    value: userMessage
  });
};

TextArea.propTypes = {
  userMessage: _propTypes.default.string.isRequired,
  handleChange: _propTypes.default.func.isRequired,
  handleKeyPress: _propTypes.default.func.isRequired,
  textareaRef: _propTypes.default.shape({
    current: _propTypes.default.instanceOf(Element)
  }).isRequired,
  disabled: _propTypes.default.bool.isRequired
};
var _default = TextArea;
exports.default = _default;